import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  CreateApplicationType,
  UpdateApplicationType,
} from "@/domain/applications";

import { ApplicationsApi } from "../api/applicationsApi";
import { ApplicationsQueryKeys } from "../queries/applicationsQueries";

export const useCreateApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (applicationData: CreateApplicationType) =>
      ApplicationsApi.createApplication(applicationData),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ApplicationsQueryKeys.all,
      });
    },
  });
};

export const useDeleteDraftApplicationsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => ApplicationsApi.deleteDraftApplications(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ApplicationsQueryKeys.all,
      });
    },
  });
};

export const useUpdateApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      applicationData,
    }: {
      id: string;
      applicationData: UpdateApplicationType;
    }) => ApplicationsApi.updateApplication(id, applicationData),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ApplicationsQueryKeys.all,
      });
    },
  });
};
